import { Modal } from "@monsterindia/global-ui-components";

import { ApopProps } from "../../../../types/apop";
import { EmploymentApop } from "../../employment";

type CurrentEmploymentDetailProps = {
  showCurrentEmploymentDetails?: boolean;
} & ApopProps;

export const CurrentEmploymentDetailsWrapper = ({
  showCurrentEmploymentDetails,
  backBtnClickHandler,
  closeApop,
  nextApopType,
  onCTA,
  toast,
  prefilledData,
  flowType,
  handleEventTracking,
}: CurrentEmploymentDetailProps) => {
  return (
    <>
      {window.innerWidth < 768 ? (
        <Modal
          showModal={showCurrentEmploymentDetails}
          closeModal={closeApop}
          isMobile={true}
          showCloseButton={false}
          showHandleBar={true} // Height problem
          screenAlignment="bottom-sheet"
        >
          <EmploymentApop
            nextApopType={nextApopType}
            backBtnClickHandler={backBtnClickHandler}
            closeApop={closeApop}
            onCTA={onCTA}
            toast={toast}
            prefilledData={prefilledData}
            flowType={flowType}
            handleEventTracking={handleEventTracking}
          />
        </Modal>
      ) : (
        <EmploymentApop
          nextApopType={nextApopType}
          backBtnClickHandler={backBtnClickHandler}
          closeApop={closeApop}
          onCTA={onCTA}
          toast={toast}
          prefilledData={prefilledData}
          flowType={flowType}
          handleEventTracking={handleEventTracking}
        />
      )}
    </>
  );
};
